module.exports = __webpack_public_path__ + "static/img/home-3.ac1ae4db.png";